import { render, staticRenderFns } from "./tabList.vue?vue&type=template&id=1e69a36e&scoped=true&"
import script from "./tabList.vue?vue&type=script&lang=js&"
export * from "./tabList.vue?vue&type=script&lang=js&"
import style0 from "./tabList.vue?vue&type=style&index=0&id=1e69a36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e69a36e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e69a36e')) {
      api.createRecord('1e69a36e', component.options)
    } else {
      api.reload('1e69a36e', component.options)
    }
    module.hot.accept("./tabList.vue?vue&type=template&id=1e69a36e&scoped=true&", function () {
      api.rerender('1e69a36e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/market/tabList.vue"
export default component.exports